import { useMemo } from 'react';

export const useIsWebview = () => {
  return useMemo(() => {
    if (typeof window === 'undefined') {
      return false;
    }

    const webkit = window?.webkit?.messageHandlers;
    const hasNativeBridge = !!(webkit?.insights || webkit?.shop || webkit?.button);

    const ua = window.navigator.userAgent;
    const isAndroidWebView = /; wv\)/.test(ua);

    const isIosDevice = /iPhone|iPod|iPad/.test(ua);
    const isIosWebView = isIosDevice && !/Safari\//.test(ua);

    return hasNativeBridge || isAndroidWebView || isIosWebView;
  }, []);
};
